import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { PropertyAddMediaDto, PropertyCreationStep, PropertyDto } from '@workspace/data-types';
import { DtoChangedDetection } from '@workspace/ng-aura';
import { PropertyMissingInfoUtils } from '../../../utils/property-missing-info.utils';
import { EtxePropertySectionReminderComponent } from '../../property-section-reminder/property-section-reminder.component';
import { PropertyPhotosDisplayComponent } from '../display/photos-display.component';
import { PropertyPhotosFormComponent } from '../form/photos-form.component';

@Component({
  selector: 'etxe-property-photos-edit',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PropertyPhotosDisplayComponent,
    PropertyPhotosFormComponent,
    EtxePropertySectionReminderComponent,
  ],
  templateUrl: './photos-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyPhotosEditComponent {
  property = input.required<PropertyDto>();
  editMode = input.required<boolean>();
  editable = input<boolean>(true);
  saving = input<boolean>(false);

  missingItems = computed(() =>
    PropertyMissingInfoUtils.getMissingItemsByStep(this.property(), PropertyCreationStep.PHOTOS),
  );

  editToggled = output<void>();
  cancelToggled = output<void>();
  dtoChanged = output<DtoChangedDetection<PropertyAddMediaDto>>();
  submitted = output<void>();

  onEdit() {
    this.editToggled.emit();
  }

  onCancel() {
    this.cancelToggled.emit();
  }

  onDtoChanged(event: DtoChangedDetection<PropertyAddMediaDto>) {
    this.dtoChanged.emit(event);
  }

  onSubmit() {
    this.submitted.emit();
  }
}
